import { render, staticRenderFns } from "./MealsUpDateStudent.vue?vue&type=template&id=c550127a&scoped=true&"
import script from "./MealsUpDateStudent.vue?vue&type=script&lang=js&"
export * from "./MealsUpDateStudent.vue?vue&type=script&lang=js&"
import style0 from "./MealsUpDateStudent.vue?vue&type=style&index=0&id=c550127a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c550127a",
  null
  
)

export default component.exports